module.exports = __webpack_public_path__ + "img/cut2icon.91086265.png";